import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import translationEs from "./locales/es/translation.json";
import translationEn from "./locales/en/translation.json";
import translationPt from "./locales/pt/translation.json"; // Importar la traducción en portugués

// translations
const resources = {
  es: {
    translation: translationEs,
  },
  en: {
    translation: translationEn,
  },
  pt: {
    translation: translationPt,
  },
};

i18n
  .use(detector)
  .use(initReactI18next) // pasa i18n a react-i18next
  .init({
    resources,
    lng: "es", // idioma predeterminado
    fallbackLng: "en", // usar inglés si el idioma detectado no está disponible

    keySeparator: false, // no se usan claves en forma de mensajes.welcome

    interpolation: {
      escapeValue: false, // react ya previene XSS
    },
  });

export default i18n;


